import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {PaymentRequestOnlineAttemptModel} from "../../../api/entity/paymentRequestOnlineAttempt.model";
import {
    PaymentRequestOnlineAttemptConverter
} from "../../../api/entity/converter/paymentRequestOnlineAttempt.converter";

@Injectable({providedIn: 'root'})
export class PaymentRequestOnlineAttemptDataService extends AbstractDataServiceV2<PaymentRequestOnlineAttemptModel, PaymentRequestOnlineAttemptConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: PaymentRequestOnlineAttemptConverter
    ) {
        super('PaymentRequestOnlineAttempt', http, httpUrlGenerator, logger, config, converter);
    }
}
